import React, { useEffect, useState, useRef } from 'react'
import Icon from 'components/Icon'

const DemoPlayer = ({ src, className, iconClassName }) => {
  const [playing, setPlaying] = useState(false)
  const audioRef = useRef()

  useEffect(() => {
    if (audioRef.current.paused && playing) {
      audioRef.current.play()
    } else {
      audioRef.current.pause()
    }
  }, [playing])

  const onClick = (event) => {
    event.preventDefault()
    event.stopPropagation()
    setPlaying(!playing)
  }

  return (
    <React.Fragment>
      <audio controls src={src} preload="none" className="hidden" ref={audioRef} onEnded={() => setPlaying(false)}>
        HTML5 <code>audio</code> not supported.
      </audio>

      <div className={className || 'z-50 cursor-pointer rounded-full w-10 h-10 bg-primary flex items-center justify-center'} onClick={onClick}>
        <Icon icon={['fas', playing ? 'pause' : 'play']} className={iconClassName || 'fa-fw text-white text-sm'} />
      </div>
    </React.Fragment>
  )
}

export default DemoPlayer
